export const translations = {
  en: {
    app: {
      title: 'Converter Tools',
    },
    common: {
      appTitle: 'Converter Tools',
      convert: 'Convert',
      converting: 'Converting...',
      result: 'Result',
      lastUpdated: 'Last Updated',
      inputValue: 'Input Value',
      from: 'From',
      to: 'To',
      pleaseEnterValue: 'Please enter a value',
      pleaseEnterValidNumber: 'Please enter a valid number',
      serverError: 'Server did not return JSON. Please check backend status.',
      conversionFailed: 'Conversion failed',
      conversionFailedPleaseTryAgain: 'Conversion failed. Please try again.',
      footerText: 'Converter Tools - Your All-in-One Conversion Solution',
      selectFile: 'Select File',
      fileSelected: 'File Selected',
      fileSize: 'Size',
      startConversion: 'Start Conversion',
      errorOccurred: 'An error occurred',
      pleaseSelectFile: 'Please select a file first',
      welcome: 'Welcome to Converter Tools',
      selectTool: 'Please select a tool to use',
      enterAmount: 'Enter Amount',
      enterValue: 'Enter Value',
      swapUnits: 'Swap Units',
      selectDateTime: 'Select Date and Time',
      fromTimeZone: 'From Time Zone',
      toTimeZone: 'To Time Zone',
      originalTime: 'Original Time',
      convertedTime: 'Converted Time',
      pleaseSelectDateTime: 'Please select date and time',
      pleaseSelectDifferentTimeZones: 'Please select different time zones for conversion',
      dateTimePlaceholder: 'MM/DD/YYYY HH:MM',
      dateTimeHelperText: 'Please select date and time (MM/DD/YYYY HH:MM)',
      exchangeRate: 'Exchange Rate',
      conversionRate: 'Conversion Rate',
      pleaseEnterAmount: 'Please enter amount',
    },
    nav: {
      home: 'Home',
      currency: 'Currency',
      volume: 'Volume',
      weight: 'Weight',
      length: 'Length',
      temperature: 'Temperature',
      timezone: 'Timezone',
      mp4ToMp3: 'MP4 to MP3',
      imageToPdf: 'Images to PDF',
      pngToJpg: 'PNG to JPG',
    },
    currencies: {
      USD: 'US Dollar (USD)',
      EUR: 'Euro (EUR)',
      GBP: 'British Pound (GBP)',
      JPY: 'Japanese Yen (JPY)',
      CNY: 'Chinese Yuan (CNY)',
      AUD: 'Australian Dollar (AUD)',
      CAD: 'Canadian Dollar (CAD)',
      CHF: 'Swiss Franc (CHF)',
      HKD: 'Hong Kong Dollar (HKD)',
      SGD: 'Singapore Dollar (SGD)',
      KRW: 'South Korean Won (KRW)',
      THB: 'Thai Baht (THB)',
      MYR: 'Malaysian Ringgit (MYR)',
      IDR: 'Indonesian Rupiah (IDR)',
      PHP: 'Philippine Peso (PHP)',
      VND: 'Vietnamese Dong (VND)',
      BRL: 'Brazilian Real (BRL)',
      MXN: 'Mexican Peso (MXN)',
      ARS: 'Argentine Peso (ARS)',
      CLP: 'Chilean Peso (CLP)',
      PEN: 'Peruvian Sol (PEN)',
      COP: 'Colombian Peso (COP)',
      UYU: 'Uruguayan Peso (UYU)',
      PYG: 'Paraguayan Guarani (PYG)',
      BOB: 'Bolivian Boliviano (BOB)',
      NOK: 'Norwegian Krone (NOK)',
      SEK: 'Swedish Krona (SEK)',
      DKK: 'Danish Krone (DKK)',
      PLN: 'Polish Złoty (PLN)',
      CZK: 'Czech Koruna (CZK)',
      HUF: 'Hungarian Forint (HUF)',
      RON: 'Romanian Leu (RON)',
      BGN: 'Bulgarian Lev (BGN)',
      HRK: 'Croatian Kuna (HRK)',
      RSD: 'Serbian Dinar (RSD)',
      TRY: 'Turkish Lira (TRY)',
      ILS: 'Israeli Shekel (ILS)',
      EGP: 'Egyptian Pound (EGP)',
      ZAR: 'South African Rand (ZAR)',
      NGN: 'Nigerian Naira (NGN)',
      KES: 'Kenyan Shilling (KES)',
      GHS: 'Ghanaian Cedi (GHS)',
      UGX: 'Ugandan Shilling (UGX)',
      TZS: 'Tanzanian Shilling (TZS)',
      MAD: 'Moroccan Dirham (MAD)',
      TND: 'Tunisian Dinar (TND)',
      DZD: 'Algerian Dinar (DZD)',
      LYD: 'Libyan Dinar (LYD)',
    },
    weightUnits: {
      mg: 'Milligram (mg)',
      g: 'Gram (g)',
      kg: 'Kilogram (kg)',
      t: 'Metric Ton (t)',
      oz: 'Ounce (oz)',
      lb: 'Pound (lb)',
      st: 'Stone (st)',
      cwt: 'Hundredweight (cwt)',
      gr: 'Grain (gr)',
      ct: 'Carat (ct)',
    },
    lengthUnits: {
      mm: 'Millimeter (mm)',
      cm: 'Centimeter (cm)',
      m: 'Meter (m)',
      km: 'Kilometer (km)',
      in: 'Inch (in)',
      ft: 'Foot (ft)',
      yd: 'Yard (yd)',
      mi: 'Mile (mi)',
      nm: 'Nautical Mile (nm)',
      ly: 'Light Year (ly)',
    },
    temperatureUnits: {
      c: 'Celsius (°C)',
      f: 'Fahrenheit (°F)',
      k: 'Kelvin (K)',
      r: 'Rankine (°R)',
    },
    timeZones: {
      UTC: 'UTC (Coordinated Universal Time)',
      'Asia/Shanghai': 'Asia/Shanghai (Beijing, Shanghai)',
      'Asia/Tokyo': 'Asia/Tokyo (Tokyo, Seoul)',
      'America/New_York': 'America/New_York (Eastern Time)',
      'America/Los_Angeles': 'America/Los_Angeles (Pacific Time)',
      'Europe/London': 'Europe/London (London, Dublin)',
      'Europe/Paris': 'Europe/Paris (Paris, Berlin)',
      'Australia/Sydney': 'Australia/Sydney (Sydney)',
      'Asia/Kolkata': 'Asia/Kolkata (India Standard Time)',
      'Europe/Moscow': 'Europe/Moscow (Moscow)',
      'Africa/Cairo': 'Africa/Cairo (Cairo)',
      'America/Sao_Paulo': 'America/Sao_Paulo (São Paulo)',
      'Pacific/Auckland': 'Pacific/Auckland (Auckland)',
      'Asia/Singapore': 'Asia/Singapore (Singapore)',
      'Asia/Hong_Kong': 'Asia/Hong_Kong (Hong Kong)',
    },
    errors: {
      invalidResponse: 'Server returned invalid response',
      conversionFailed: 'Conversion failed',
      pleaseSelectValidVideo: 'Please select a valid video file (MP4, AVI, MOV, MKV, WebM)',
      pleaseSelectVideoFirst: 'Please select a video file first',
    },
    units: {
      volume: {
        cubicMillimeter: 'Cubic Millimeter (mm³)',
        cubicCentimeter: 'Cubic Centimeter (cm³)',
        milliliter: 'Milliliter (ml)',
        liter: 'Liter (l)',
        cubicMeter: 'Cubic Meter (m³)',
        cubicInch: 'Cubic Inch (in³)',
        cubicFoot: 'Cubic Foot (ft³)',
        cubicYard: 'Cubic Yard (yd³)',
        gallon: 'Gallon (gal)',
        quart: 'Quart (qt)',
        pint: 'Pint (pt)',
        cup: 'Cup',
        fluidOunce: 'Fluid Ounce (oz)',
        tablespoon: 'Tablespoon (tbsp)',
        teaspoon: 'Teaspoon (tsp)',
      },
    },
    features: {
      title: 'Features',
      description: 'What makes Converter Tools special',
      items: {
        accuracy: {
          title: 'High Accuracy',
          description: 'Precise conversions with up-to-date exchange rates and formulas'
        },
        speed: {
          title: 'Fast & Efficient',
          description: 'Instant conversions with real-time updates'
        },
        units: {
          title: 'Comprehensive Units',
          description: 'Support for multiple units and formats across different categories'
        },
        interface: {
          title: 'User-Friendly Interface',
          description: 'Clean and intuitive design for easy navigation'
        }
      }
    },
    howToUse: {
      title: 'How to Use Converter Tools',
      description: 'Simple steps to convert your files',
      steps: {
        step1: 'Select the type of conversion you need',
        step2: 'Upload your file or enter the value to convert',
        step3: 'Choose your desired output format or unit',
        step4: 'Click convert and download your result'
      }
    },
    whyLove: {
      title: 'Why Users Love Converter Tools',
      description: 'Discover what makes our converter tools special',
      reasons: {
        reason1: 'Fast and accurate conversions',
        reason2: 'Support for multiple file formats',
        reason3: 'Easy to use interface',
        reason4: 'Free to use',
        reason5: 'No registration required',
        reason6: 'Secure file processing'
      }
    },
    whatPlayersLove: {
      title: 'What Players Love About Converter Tools',
      description: 'See why gamers choose our converter tools',
      features: {
        feature1: 'Perfect for game file conversions',
        feature2: 'Supports popular gaming formats',
        feature3: 'Quick processing for large files',
        feature4: 'Maintains game file integrity',
        feature5: 'Ideal for modding and customization',
        feature6: 'Compatible with major game platforms'
      }
    },
    testimonials: {
      title: 'User Testimonials',
      items: {
        user1: {
          name: 'John Smith',
          role: 'Professional Trader',
          text: 'The currency converter is incredibly accurate and updates in real-time. It\'s become an essential tool for my daily trading activities.'
        },
        user2: {
          name: 'Sarah Johnson',
          role: 'Engineering Student',
          text: 'As an engineering student, I need to convert units frequently. This tool has made my calculations much easier and more reliable.'
        },
        user3: {
          name: 'Michael Chen',
          role: 'Software Developer',
          text: 'The API integration is seamless, and the documentation is clear. It\'s been a great addition to our development toolkit.'
        }
      }
    },
    converters: {
      volume: {
        title: 'Volume Converter',
        description: 'Convert between different volume units',
      },
      length: {
        title: 'Length Converter',
        description: 'Convert between different length units',
      },
      weight: {
        title: 'Weight Converter',
        description: 'Convert between different weight units',
      },
      temperature: {
        title: 'Temperature Converter',
        description: 'Convert between different temperature units',
      },
      currency: {
        title: 'Currency Converter',
        description: 'Convert between different currencies using real-time exchange rates',
      },
      timezone: {
        title: 'Timezone Converter',
        description: 'Convert time between different time zones',
      },
      pngToJpg: {
        title: 'PNG to JPG Converter',
        description: 'Convert PNG images to JPG format',
      },
      imageToPdf: {
        title: 'Images to PDF Converter',
        description: 'Convert multiple images to a single PDF document',
      },
      mp4ToMp3: {
        title: 'MP4 to MP3 Converter',
        description: 'Convert MP4 video files to MP3 audio format',
      },
    },
    imageToPdfConverter: {
      title: 'Images to PDF',
      description: 'Convert multiple images to a single PDF document',
      selectImageFiles: 'Select Images',
      dragDropFiles: 'Drag and drop image files here or click to upload',
      dropFilesHere: 'Drop files here',
      supportedFormats: 'Supported Formats: JPG, JPEG, PNG, BMP, TIFF',
      maxFileSize: 'Maximum File Size: 10MB per image',
      generatePdf: 'Generate PDF',
      imageList: 'Image List',
      pending: 'Pending',
      uploading: 'Uploading',
      converting: 'Converting',
      completed: 'Completed',
      error: 'Error',
      download: 'Download PDF',
      retry: 'Retry',
      remove: 'Remove',
      moveUp: 'Move Up',
      moveDown: 'Move Down',
      conversionSuccess: 'PDF generated successfully!',
      conversionFailed: 'PDF generation failed',
      downloadFailed: 'Download failed',
      pleaseSelectImages: 'Please select at least one image file',
      pleaseSelectValidImages: 'Please select valid image files',
      startConversion: 'Generate PDF',
      pageSettings: 'Page Settings',
      pageSize: 'Page Size',
      imageQuality: 'Image Quality',
      fitToPage: 'Fit to Page',
      originalSize: 'Original Size',
      apiNote: 'Note: This function combines multiple images into a single PDF document with customizable settings.',
      reorderInstructions: 'Drag images to reorder them in the PDF',
      noImagesSelected: 'No images selected. Please upload some images first.',
      
      // PDF Settings
      pdfSettings: 'PDF Settings',
      
      // Image list
      pagePrefix: 'Page',
      
      // Move actions
      moveUpTitle: 'Move Up',
      moveDownTitle: 'Move Down',
      deleteTitle: 'Delete',
      
      // Success section
      pdfGeneratedSuccess: 'PDF Generated Successfully!',
      
      // Info section
      pdfGenerationTitle: '✨ PDF Generation',
      pdfGenerationFeatures: '• Files are not uploaded to any server, protecting your privacy\n• Support for multiple page sizes and image quality settings\n• Adjustable image order, one image per page',
      
      // Error messages
      cannotCreate2DContext: 'Cannot create 2D rendering context',
      imageLoadFailed: 'Image loading failed',
      jsPdfLoadFailed: 'jsPDF loading failed',
    },
    pngToJpgConverter: {
      title: 'PNG to JPG',
      description: 'Convert PNG images to JPG format',
      dragDropFiles: 'Drag PNG files here, or click to select files',
      dropFilesHere: 'Drop PNG files here',
      supportedFormats: 'Supported Formats: PNG (Client-side conversion, no server required)',
      maxFileSize: 'Maximum File Size: 10MB',
      convertAll: 'Convert All',
      fileList: 'File List',
      pending: 'Pending',
      converting: 'Converting',
      completed: 'Completed',
      error: 'Error',
      download: 'Download JPG File',
      retry: 'Retry Conversion',
      remove: 'Remove File',
      conversionSuccess: 'Conversion successful!',
      conversionFailed: 'Conversion failed',
      downloadFailed: 'Download failed',
      infoTitle: '✨ PNG to JPG',
      infoDescription: '• No server required, conversion happens entirely in your browser',
      infoDescription2: '• Files are not uploaded to any server, protecting your privacy',
      infoDescription3: '• Supports batch conversion with fast processing',
      infoDescription4: '• PNG transparent backgrounds are automatically filled with white',
      
      // Error messages
      cannotCreate2DContext: 'Cannot create 2D rendering context',
      imageLoadFailed: 'Image loading failed',
      fileReadFailed: 'File reading failed',
    },
    mp4Converter: {
      title: 'MP4 to MP3',
      description: 'Convert video files to MP3 audio format',
      selectVideoFile: 'Select Video File',
      dragDropFiles: 'Drag and drop files here or click to upload',
      dropFilesHere: 'Drop files here',
      supportedFormats: 'Supported Formats: MP4, AVI, MOV, MKV, WebM, FLV, WMV',
      maxFileSize: 'Maximum File Size: 100MB',
      convertAll: 'Convert All',
      fileList: 'File List',
      pending: 'Pending',
      uploading: 'Uploading',
      converting: 'Converting',
      completed: 'Completed',
      error: 'Error',
      download: 'Download',
      retry: 'Retry',
      remove: 'Remove',
      conversionSuccess: 'Conversion successful!',
      conversionFailed: 'Conversion failed',
      downloadFailed: 'Download failed',
      pleaseSelectVideo: 'Please select at least one video file',
      pleaseSelectValidVideo: 'Please select valid video files',
      recordingFailed: 'Recording failed',
      videoLoadFailed: 'Video loading failed',
      backendApiFailed: 'Backend API conversion failed, trying client-side conversion',
      noteMessage: 'Note: This function outputs in WebM format. For higher quality MP3 conversion, it is recommended to use professional backend services.',
    },
  },
  zh: {
    app: {
      title: '转换工具',
    },
    common: {
      appTitle: '转换工具',
      convert: '转换',
      converting: '转换中...',
      result: '结果',
      lastUpdated: '最后更新',
      inputValue: '输入值',
      from: '从',
      to: '到',
      pleaseEnterValue: '请输入一个值',
      pleaseEnterValidNumber: '请输入一个有效的数字',
      serverError: '服务器未返回JSON格式数据，请检查后端状态',
      conversionFailed: '转换失败',
      conversionFailedPleaseTryAgain: '转换失败，请重试',
      footerText: '转换工具 - 多功能在线转换平台',
      selectFile: '选择文件',
      fileSelected: '已选择文件',
      fileSize: '大小',
      startConversion: '开始转换',
      errorOccurred: '发生错误',
      pleaseSelectFile: '请先选择文件',
      welcome: '欢迎使用转换工具',
      selectTool: '请选择要使用的工具',
      enterAmount: '输入金额',
      enterValue: '输入数值',
      swapUnits: '交换单位',
      selectDateTime: '选择日期和时间',
      fromTimeZone: '源时区',
      toTimeZone: '目标时区',
      originalTime: '原始时间',
      convertedTime: '转换后时间',
      pleaseSelectDateTime: '请选择日期和时间',
      pleaseSelectDifferentTimeZones: '请选择不同的时区进行转换',
      dateTimePlaceholder: '年/月/日 时:分',
      dateTimeHelperText: '请选择日期和时间 (年/月/日 时:分)',
      exchangeRate: '汇率',
      conversionRate: '转换率',
      pleaseEnterAmount: '请输入金额',
    },
    nav: {
      home: '首页',
      currency: '货币',
      volume: '体积',
      weight: '重量',
      length: '长度',
      temperature: '温度',
      timezone: '时区',
      mp4ToMp3: 'MP4转MP3',
      imageToPdf: '图片转PDF',
      pngToJpg: 'PNG转JPG',
    },
    currencies: {
      USD: '美元 (USD)',
      EUR: '欧元 (EUR)',
      GBP: '英镑 (GBP)',
      JPY: '日元 (JPY)',
      CNY: '人民币 (CNY)',
      AUD: '澳元 (AUD)',
      CAD: '加元 (CAD)',
      CHF: '瑞士法郎 (CHF)',
      HKD: '港币 (HKD)',
      SGD: '新加坡元 (SGD)',
      KRW: '韩元 (KRW)',
      THB: '泰铢 (THB)',
      MYR: '马来西亚林吉特 (MYR)',
      IDR: '印尼盾 (IDR)',
      PHP: '菲律宾比索 (PHP)',
      VND: '越南盾 (VND)',
      BRL: '巴西雷亚尔 (BRL)',
      MXN: '墨西哥比索 (MXN)',
      ARS: '阿根廷比索 (ARS)',
      CLP: '智利比索 (CLP)',
      PEN: '秘鲁索尔 (PEN)',
      COP: '哥伦比亚比索 (COP)',
      UYU: '乌拉圭比索 (UYU)',
      PYG: '巴拉圭瓜拉尼 (PYG)',
      BOB: '玻利维亚诺 (BOB)',
      NOK: '挪威克朗 (NOK)',
      SEK: '瑞典克朗 (SEK)',
      DKK: '丹麦克朗 (DKK)',
      PLN: '波兰兹罗提 (PLN)',
      CZK: '捷克克朗 (CZK)',
      HUF: '匈牙利福林 (HUF)',
      RON: '罗马尼亚列伊 (RON)',
      BGN: '保加利亚列弗 (BGN)',
      HRK: '克罗地亚库纳 (HRK)',
      RSD: '塞尔维亚第纳尔 (RSD)',
      TRY: '土耳其里拉 (TRY)',
      ILS: '以色列新谢克尔 (ILS)',
      EGP: '埃及镑 (EGP)',
      ZAR: '南非兰特 (ZAR)',
      NGN: '尼日利亚奈拉 (NGN)',
      KES: '肯尼亚先令 (KES)',
      GHS: '加纳塞地 (GHS)',
      UGX: '乌干达先令 (UGX)',
      TZS: '坦桑尼亚先令 (TZS)',
      MAD: '摩洛哥迪拉姆 (MAD)',
      TND: '突尼斯第纳尔 (TND)',
      DZD: '阿尔及利亚第纳尔 (DZD)',
      LYD: '利比亚第纳尔 (LYD)',
    },
    weightUnits: {
      mg: '毫克 (mg)',
      g: '克 (g)',
      kg: '千克 (kg)',
      t: '吨 (t)',
      oz: '盎司 (oz)',
      lb: '磅 (lb)',
      st: '英石 (st)',
      cwt: '英担 (cwt)',
      gr: '格令 (gr)',
      ct: '克拉 (ct)',
    },
    lengthUnits: {
      mm: '毫米 (mm)',
      cm: '厘米 (cm)',
      m: '米 (m)',
      km: '千米 (km)',
      in: '英寸 (in)',
      ft: '英尺 (ft)',
      yd: '码 (yd)',
      mi: '英里 (mi)',
      nm: '海里 (nm)',
      ly: '光年 (ly)',
    },
    temperatureUnits: {
      c: '摄氏度 (°C)',
      f: '华氏度 (°F)',
      k: '开尔文 (K)',
      r: '兰氏度 (°R)',
    },
    timeZones: {
      UTC: 'UTC (协调世界时)',
      'Asia/Shanghai': 'Asia/Shanghai (北京, 上海)',
      'Asia/Tokyo': 'Asia/Tokyo (东京, 首尔)',
      'America/New_York': 'America/New_York (东部时间)',
      'America/Los_Angeles': 'America/Los_Angeles (太平洋时间)',
      'Europe/London': 'Europe/London (伦敦, 都柏林)',
      'Europe/Paris': 'Europe/Paris (巴黎, 柏林)',
      'Australia/Sydney': 'Australia/Sydney (悉尼)',
      'Asia/Kolkata': 'Asia/Kolkata (印度标准时间)',
      'Europe/Moscow': 'Europe/Moscow (莫斯科)',
      'Africa/Cairo': 'Africa/Cairo (开罗)',
      'America/Sao_Paulo': 'America/Sao_Paulo (圣保罗)',
      'Pacific/Auckland': 'Pacific/Auckland (奥克兰)',
      'Asia/Singapore': 'Asia/Singapore (新加坡)',
      'Asia/Hong_Kong': 'Asia/Hong_Kong (香港)',
    },
    errors: {
      invalidResponse: '服务器返回了无效的响应',
      conversionFailed: '转换失败',
      pleaseSelectValidVideo: '请选择有效的视频文件（MP4, AVI, MOV, MKV, WebM）',
      pleaseSelectVideoFirst: '请先选择视频文件',
    },
    units: {
      volume: {
        cubicMillimeter: '立方毫米 (mm³)',
        cubicCentimeter: '立方厘米 (cm³)',
        milliliter: '毫升 (ml)',
        liter: '升 (l)',
        cubicMeter: '立方米 (m³)',
        cubicInch: '立方英寸 (in³)',
        cubicFoot: '立方英尺 (ft³)',
        cubicYard: '立方码 (yd³)',
        gallon: '加仑 (gal)',
        quart: '夸脱 (qt)',
        pint: '品脱 (pt)',
        cup: '杯',
        fluidOunce: '液体盎司 (oz)',
        tablespoon: '汤匙 (tbsp)',
        teaspoon: '茶匙 (tsp)',
      },
    },
    features: {
      title: '特色功能',
      description: '转换工具的独特之处',
      items: {
        accuracy: {
          title: '高精度',
          description: '使用最新的汇率和公式进行精确转换'
        },
        speed: {
          title: '快速高效',
          description: '实时更新，即时转换'
        },
        units: {
          title: '全面的单位',
          description: '支持多种不同类别的单位和格式'
        },
        interface: {
          title: '用户友好界面',
          description: '清晰直观的设计，易于操作'
        }
      }
    },
    howToUse: {
      title: '如何使用转换工具',
      description: '简单的转换步骤',
      steps: {
        step1: '选择需要的转换类型',
        step2: '上传文件或输入要转换的值',
        step3: '选择所需的输出格式或单位',
        step4: '点击转换并下载结果'
      }
    },
    whyLove: {
      title: '为什么用户喜欢转换工具',
      description: '发现我们转换工具的特别之处',
      reasons: {
        reason1: '快速准确的转换',
        reason2: '支持多种文件格式',
        reason3: '简单易用的界面',
        reason4: '完全免费使用',
        reason5: '无需注册',
        reason6: '安全的文件处理'
      }
    },
    whatPlayersLove: {
      title: '玩家喜爱的转换工具',
      description: '了解为什么玩家选择我们的转换工具',
      features: {
        feature1: '完美的游戏文件转换',
        feature2: '支持主流游戏格式',
        feature3: '快速处理大文件',
        feature4: '保持游戏文件完整性',
        feature5: '适合模组和自定义',
        feature6: '兼容主要游戏平台'
      }
    },
    testimonials: {
      title: '用户评价',
      items: {
        user1: {
          name: '约翰·史密斯',
          role: '专业交易员',
          text: '货币转换器非常准确，并且实时更新。它已经成为我日常交易活动中必不可少的工具。'
        },
        user2: {
          name: '莎拉·约翰逊',
          role: '工程学学生',
          text: '作为一名工程学学生，我经常需要转换单位。这个工具使我的计算更加容易和可靠。'
        },
        user3: {
          name: '陈明',
          role: '软件开发者',
          text: 'API集成非常顺畅，文档清晰明了。它是我们开发工具包的重要补充。'
        }
      }
    },
    converters: {
      volume: {
        title: '体积转换器',
        description: '在不同体积单位之间转换',
      },
      length: {
        title: '长度转换器',
        description: '在不同长度单位之间转换',
      },
      weight: {
        title: '重量转换器',
        description: '在不同重量单位之间转换',
      },
      temperature: {
        title: '温度转换器',
        description: '在不同温度单位之间转换',
      },
      currency: {
        title: '货币转换器',
        description: '使用实时汇率在不同货币之间转换',
      },
      timezone: {
        title: '时区转换器',
        description: '在不同时区之间转换时间',
      },
      pngToJpg: {
        title: 'PNG转JPG转换器',
        description: '将PNG图片转换为JPG格式',
      },
      imageToPdf: {
        title: '图片转PDF转换器',
        description: '将多张图片合并为单个PDF文档',
      },
      mp4ToMp3: {
        title: 'MP4转MP3转换器',
        description: '将MP4视频文件转换为MP3音频格式',
      },
    },
    imageToPdfConverter: {
      title: '图片转PDF',
      description: '将多张图片合并为单个PDF文档',
      selectImageFiles: '选择图片',
      dragDropFiles: '拖拽图片文件到此处或点击上传',
      dropFilesHere: '释放文件到此处',
      supportedFormats: '支持格式：JPG, JPEG, PNG, BMP, TIFF',
      maxFileSize: '每张图片最大：10MB',
      generatePdf: '生成PDF',
      imageList: '图片列表',
      pending: '等待中',
      uploading: '上传中',
      converting: '生成中',
      completed: '已完成',
      error: '错误',
      download: '下载PDF',
      retry: '重试',
      remove: '移除',
      moveUp: '上移',
      moveDown: '下移',
      conversionSuccess: 'PDF生成成功！',
      conversionFailed: 'PDF生成失败',
      downloadFailed: '下载失败',
      pleaseSelectImages: '请至少选择一张图片',
      pleaseSelectValidImages: '请选择有效的图片文件',
      startConversion: '生成PDF',
      pageSettings: '页面设置',
      pageSize: '页面大小',
      imageQuality: '图片质量',
      fitToPage: '适应页面',
      originalSize: '原始大小',
      apiNote: '注意：此功能将多张图片合并为单个PDF文档，支持自定义设置。',
      reorderInstructions: '拖拽图片以调整在PDF中的顺序',
      noImagesSelected: '未选择图片。请先上传一些图片。',
      
      // PDF Settings
      pdfSettings: 'PDF设置',
      
      // Image list
      pagePrefix: '第',
      
      // Move actions
      moveUpTitle: '向上移动',
      moveDownTitle: '向下移动',
      deleteTitle: '删除',
      
      // Success section
      pdfGeneratedSuccess: 'PDF生成成功！',
      
      // Info section
      pdfGenerationTitle: '✨ PDF生成',
      pdfGenerationFeatures: '• 文件不会上传到任何服务器，保护您的隐私\n• 支持多种页面尺寸和图片质量设置\n• 可调整图片顺序，每张图片一页',
      
      // Error messages
      cannotCreate2DContext: '无法创建2D渲染上下文',
      imageLoadFailed: '图片加载失败',
      jsPdfLoadFailed: 'jsPDF加载失败',
    },
    pngToJpgConverter: {
      title: 'PNG转JPG',
      description: '将PNG图片转换为JPG格式',
      dragDropFiles: '拖拽PNG文件到这里，或点击选择文件',
      dropFilesHere: '拖放PNG文件到这里',
      supportedFormats: '支持格式：PNG（纯前端转换，无需服务器）',
      maxFileSize: '最大文件大小：10MB',
      convertAll: '转换全部',
      fileList: '文件列表',
      pending: '等待中',
      converting: '转换中',
      completed: '已完成',
      error: '错误',
      download: '下载JPG文件',
      retry: '重试转换',
      remove: '删除文件',
      conversionSuccess: '转换成功！',
      conversionFailed: '转换失败',
      downloadFailed: '下载失败',
      infoTitle: '✨ PNG转JPG',
      infoDescription: '• 无需服务器，完全在浏览器中进行转换',
      infoDescription2: '• 文件不会上传到任何服务器，保护您的隐私',
      infoDescription3: '• 支持批量转换，速度快',
      infoDescription4: '• PNG透明背景将自动填充为白色背景',


      // Error messages
      cannotCreate2DContext: '无法创建2D渲染上下文',
      imageLoadFailed: '图片加载失败',
      fileReadFailed: '文件读取失败',
    },
    mp4Converter: {
      title: 'MP4转MP3',
      description: '将视频文件转换为音频文件，支持多种格式',
      selectVideoFile: '选择视频文件',
      dragDropFiles: '拖拽文件到此处或点击上传',
      dropFilesHere: '释放文件到此处',
      supportedFormats: '支持格式：MP4, AVI, MOV, MKV, WebM, FLV, WMV',
      maxFileSize: '最大文件大小：100MB',
      convertAll: '全部转换',
      fileList: '文件列表',
      pending: '等待中',
      uploading: '上传中',
      converting: '转换中',
      completed: '已完成',
      error: '错误',
      download: '下载',
      retry: '重试',
      remove: '移除',
      conversionSuccess: '转换成功！',
      conversionFailed: '转换失败',
      downloadFailed: '下载失败',
      pleaseSelectVideo: '请至少选择一个视频文件',
      pleaseSelectValidVideo: '请选择有效的视频文件',
      recordingFailed: '录音失败',
      videoLoadFailed: '视频加载失败',
      backendApiFailed: '后端API转换失败，尝试客户端转换',
      noteMessage: '注意：此功能输出为WebM格式。对于更高品质的MP3转换，建议使用专业后端服务。',
    },
  },
}; 